import ToastContent from './ToastContent';
import toast from './notify';

export default toast;
export { ToastContent, toast };
